import React, { useState, useEffect } from "react";
import LayoutHOC from "../LayoutHOC";
import { BiEdit } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { FaMoneyCheck } from "react-icons/fa";
import { BsGraphUpArrow } from "react-icons/bs";
import { JOB_DETAILS } from "../../utils/constants";
import { useParams } from "react-router-dom";
import useJobsDetails from "../../hooks/useJobsDetails";
import { FaNetworkWired } from "react-icons/fa";
import { MdOutlineRealEstateAgent } from "react-icons/md";
import { FaCity } from "react-icons/fa";
import { MdOutlineViewCompactAlt } from "react-icons/md";
import { FaRupeeSign } from "react-icons/fa";
import { FaBuromobelexperte } from "react-icons/fa6";
import { MdOutlineCastForEducation } from "react-icons/md";
import { TbListDetails } from "react-icons/tb";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope } from "react-icons/fa";
import axios from "axios";
import { useSelector } from "react-redux";


const JobDetails = () => {

  const { id } = useParams();
  const details = useJobsDetails(id);
  const [appliedCandidates, setAppliedCandidates] = useState([]);
  const user = useSelector((state) => state.user);

  console.log(details?.data?.employeementType);

  const Skills = details?.data?.skills;

  useEffect(() => {
    const fetchAppliedCandidates = async () => {
      if (!user) return; // Return if user is not logged in

      const token = user.token;
      try {
        // console.log('Fetching applied candidates for job ID:', id);
        // console.log('API URL:', `${process.env.REACT_APP_API_URL}api/jobs/get_applied_job_candidates_list/${id}`);
        // console.log('Token:', token);
        const response = await fetch(`${process.env.REACT_APP_API_URL}api/jobs/get_applied_job_candidates_list/${id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch applied candidates data");
        }

        const data = await response.json();
        console.log('API Response:', data);
        if (data.success) {
          setAppliedCandidates(data.data);
        }
      } catch (error) {
        console.error('Error fetching applied candidates:', error);
      }
    };

    if (id && user) {
      fetchAppliedCandidates();
    }
  }, [id, user]);

 

  return (
  <main id="maincontent" className="p-4 mt-14">
    <div className="bg-white py-3 px-4 rounded shadow-2">

      {/* Header */}
      <div className="flex items-center justify-between border-b pb-2">
        <h1 className="text-lg font-semibold">
          {details?.data?.jobPosiiton}
        </h1>
        <Link to="/jobs_list" className="text-blue-600">
          <IoMdArrowBack />
        </Link>
      </div>

      {/* Job Summary */}
      <div className="grid grid-cols-[120px,1fr] gap-4 my-4">
        {(() => {
          const logoUrl = details?.data?.companylogo;
          console.log('Company Logo URL:', logoUrl);
          
          // If no logo, show placeholder
          if (!logoUrl) {
            return (
              <div className="w-[110px] h-[110px] rounded-full object-cover border bg-gray-200 flex items-center justify-center">
                <span className="text-gray-400 text-xs">No Logo</span>
              </div>
            );
          }
          
          // Show both image and fallback placeholder - use CSS to handle showing/hiding
          return (
            <div className="relative w-[110px] h-[110px]">
              <img
                id="company-logo-img"
                className="w-[110px] h-[110px] rounded-full object-cover border"
                src={logoUrl}
                alt="Company Logo"
                crossOrigin="anonymous"
                onLoad={() => console.log('Image loaded successfully')}
                onError={(e) => {
                  console.error('Image failed to load');
                  console.log('Image src was:', e.target.src);
                  // Hide the broken image and show placeholder
                  e.target.style.display = 'none';
                  document.getElementById('logo-placeholder').style.display = 'flex';
                }}
              />
              <div 
                id="logo-placeholder"
                className="w-[110px] h-[110px] rounded-full object-cover border bg-gray-200 flex items-center justify-center"
                style={{ display: 'none' }}
              >
                <span className="text-gray-400 text-xs">No Logo</span>
              </div>
            </div>
          );
        })()}


       <div className="space-y-2">
          <h2 className="text-base font-medium">
            {details?.data?.jobPosiiton}
            {details?.data?.title && (
              <span className="text-sm text-gray-500 font-normal ml-1">
                · {details?.data?.title}
              </span>
            )}
          </h2>

          <p className="text-xs text-gray-500">
            Employment Type · {details?.data?.employeementType}
          </p>

          <div className="flex items-center gap-1 text-blue-600">
            <FaRupeeSign />
            <span className="text-sm font-medium">
              {details?.data?.minSalary} - {details?.data?.maxSalary}
              <small className="text-xs ml-1">
                ({details?.data?.salaryType})
              </small>
            </span>
          </div>
        </div>

      </div>

      {/* Company Details */}
      <section className="border rounded p-4 mb-4">
        <h3 className="text-base font-semibold mb-3">Company Details</h3>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
          <div>
            <span className="text-xs text-gray-500">Company Name</span>
            <p>{details?.data?.company}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Address</span>
            <p>{details?.data?.address}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Work Place</span>
            <p>{details?.data?.workPlace}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Representative</span>
            <p>{details?.data?.createdByName}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Mobile</span>
            <p>{details?.data?.phone}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Email</span>
            <p>{details?.data?.email}</p>
          </div>
        </div>
      </section>

      {/* Job / Joining Requirements */}
      <section className="border rounded p-4 mb-4">
        <h3 className="text-base font-semibold mb-3">Job & Joining Requirements</h3>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
          <div>
            <span className="text-xs text-gray-500">Salary Type</span>
            <p>{details?.data?.salaryType}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Experience</span>
            <p>{details?.data?.experience}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Education</span>
            <p>{details?.data?.education}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Total Vacancy</span>
            <p>{details?.data?.totalVacancy}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Hired</span>
            <p>{details?.data?.hired_count}</p>
          </div>

          <div>
            <span className="text-xs text-gray-500">Remaining</span>
            <p>{details?.data?.remaining_vacancies}</p>
          </div>
        </div>

        {/* Skills */}
        <div className="mt-4">
          <h4 className="text-sm font-medium mb-2">Skills</h4>
          <div className="flex flex-wrap gap-2">
            {Skills && Skills.length > 0 ? (
              Skills.map((skill, index) => (
                <span
                  key={index}
                  className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-indigo-700/10"
                >
                  {skill.name}
                </span>
              ))
            ) : (
              <p className="text-xs text-gray-500">No skills found</p>
            )}
          </div>
        </div>

        {/* Language */}
        <div className="mt-4">
          <h4 className="text-sm font-medium mb-2">Languages</h4>
          <div className="flex gap-2">
            <span className="badge">English</span>
            <span className="badge">Hindi</span>
          </div>
        </div>
      </section>

      {/* Job Description */}
      <section className="border rounded p-4 mb-4">
        <h3 className="text-base font-semibold mb-2">Job Description</h3>
        <p className="text-sm">{details?.data?.description}</p>
      </section>

      {/* Applied Candidates */}
      <section className="border rounded p-4">
        <h3 className="text-base font-semibold mb-3">Applied Candidates</h3>

        {appliedCandidates.length > 0 ? (
          <div className="space-y-2">
            {appliedCandidates.map((candidate, index) => (
              <div
                key={index}
                className="flex justify-between items-center p-2 border rounded"
              >
                <div>
                  <p className="text-sm font-medium">{candidate.name}</p>
                  <p className="text-xs text-gray-500">{candidate.email}</p>
                </div>

                <span
                  className={`px-2 py-1 text-xs rounded ${
                    candidate.application_status === "approved"
                      ? "bg-green-100 text-green-800"
                      : candidate.application_status === "rejected"
                      ? "bg-red-100 text-red-800"
                      : "bg-yellow-100 text-yellow-800"
                  }`}
                >
                  {candidate.application_status}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            No candidates have applied yet.
          </p>
        )}
      </section>
    </div>
  </main>

  );
};

export default LayoutHOC(JobDetails);
